import { Controller } from "@hotwired/stimulus"
import { installFilterHotkey } from "../../utils/filter-hotkey.util"

// Connects to data-controller="trips--filter"
// UI for the trips filter popover: open/close, sidebar tab selection, active-status dots.
export default class extends Controller {
  static targets = [
    "filterButton",
    "filterMenu",
    "filterItem",
    "filterContent",
    "activeStatusState",
    "activeStatusUser",
    "activeStatusPeriod"
  ]

  connect() {
    this.#initializeActiveStatus()
    this.removeFilterHotkey = installFilterHotkey(this)
  }

  disconnect() {
    this.removeFilterHotkey?.()
  }

  #initializeActiveStatus() {
    const urlSearchParams = new URLSearchParams(window.location.search)

    if (this.hasActiveStatusStateTarget) {
      this.toggleActiveStatus(
        urlSearchParams.has("status") && urlSearchParams.get("status") !== "",
        this.activeStatusStateTarget
      )
    }
    if (this.hasActiveStatusUserTarget) {
      this.toggleActiveStatus(
        urlSearchParams.has("user_id") && urlSearchParams.get("user_id") !== "",
        this.activeStatusUserTarget
      )
    }
    if (this.hasActiveStatusPeriodTarget) {
      this.toggleActiveStatus(
        urlSearchParams.has("start_date") || urlSearchParams.has("end_date"),
        this.activeStatusPeriodTarget
      )
    }
  }

  toggleActiveStatus(isActive, target) {
    if (isActive) {
      target.classList.remove("d-none")
    } else {
      target.classList.add("d-none")
    }
  }

  openFilterMenu() {
    this.filterMenuTarget.showPopover()
    this.filterButtonTarget.classList.add("filter-button--active")
  }

  closeFilterMenu() {
    this.filterMenuTarget.hidePopover()
    this.filterButtonTarget.classList.remove("filter-button--active")
  }

  selectFilter(event) {
    const { currentTarget } = event
    const selectedId = currentTarget.dataset.id

    this.filterItemTargets.forEach((el) => {
      el.classList.toggle("sidebar__tab--active", el === currentTarget)
    })

    this.filterContentTargets.forEach((el) => {
      el.classList.toggle("tab-content--hidden", el.id !== selectedId)
    })
  }
}
